// export const environment = {
//   DSP:false,
//   production: true,
//   version: '0.0.7',
//   endPointLoginUrl: 'https://api.enertics.ca/login/',
//   endPointUserUrl: 'https://api.enertics.ca/user/',
//   endPointDeviceUrl: 'https://api.enertics.ca/device/',
//   endPointInventoryUrl: 'https://api.enertics.ca/inventory/',
//   endPointMiddlewareUrl: 'https://api.enertics.ca/middleware/',
//   endPointSitesUrl: 'https://api.enertics.ca/sites/',
//   endPointAssetsUrl: 'https://api.enertics.ca/assets/',
//   endPointApplicationUrl: 'https://api.enertics.ca/applications/',
//   endPointUploadUrl: 'https://api.enertics.ca/upload/',
//   endPointMetricsUrl: 'https://api.enertics.ca/metrics/',
//   endPointLicenceUrl: 'https://api.enertics.ca/licence/',
//   endPointAssetServiceUrl: 'https://api.enertics.ca/service/',
//   endPointDeviceStatusUrl:'https://api.enertics.ca/devicestatus/',
//   endPointAssetReportServiceUrl: 'https://api.enertics.ca/report/',
//   endPointImageStorageUrl: 'https://enertics-prod.s3.ca-central-1.amazonaws.com/images/',
//   endPointUrl: 'https://73pzce80hf.execute-api.ca-central-1.amazonaws.com/development/v1/'
// };




// export const environment = {
//   DSP:false,
//   production: true,
//   endPointLoginUrl: 'https://prodapi.enertics.ca/login/',
//   endPointUserUrl: 'https://prodapi.enertics.ca/user/',
//   endPointDeviceUrl: 'https://prodapi.enertics.ca/device/',
//   endPointInventoryUrl: 'https://prodapi.enertics.ca/inventory/',
//   endPointMiddlewareUrl: 'https://prodapi.enertics.ca/middleware/',
//   endPointSitesUrl: 'https://prodapi.enertics.ca/sites/',
//   endPointAssetsUrl: 'https://prodapi.enertics.ca/assets/',
//   endPointApplicationUrl: 'https://prodapi.enertics.ca/applications/',
//   endPointUploadUrl: 'https://prodapi.enertics.ca/upload/',
//   endPointMetricsUrl: 'https://prodapi.enertics.ca/metrics/',
//   endPointLicenceUrl: 'https://prodapi.enertics.ca/licence/',
//   endPointAssetServiceUrl: 'https://prodapi.enertics.ca/service/',
//   endPointDeviceStatusUrl: 'https://prodapi.enertics.ca/devicestatus/',
//   endPointAssetReportServiceUrl: 'https://prodapi.enertics.ca/report/',
//   endPointImageStorageUrl: 'https://enertics-prod.s3.ca-central-1.amazonaws.com/images/',
//   endPointUrl: 'https://73pzce80hf.execute-api.ca-central-1.amazonaws.com/development/v1/'
// };

//new dev api

// ////////for QA
// export const environment = {
//   DSP:false,
//   CG:false,
//    production: false,
//    endPointLoginUrl: 'https://qaapi.enertics.ca/login/',
//    endPointUserUrl: 'https://qaapi.enertics.ca/user/',
//    endPointDeviceUrl: 'https://qaapi.enertics.ca/device/',
//    endPointInventoryUrl: 'https://qaapi.enertics.ca/inventory/',
//    endPointMiddlewareUrl: 'https://qaapi.enertics.ca/middleware/',
//    endPointKurtosisPreDomURL: 'https://qaapi.enertics.ca/kurtosis/v1/auto-regression/predominant/',
//    endPointSitesUrl: 'https://qaapi.enertics.ca/sites/',
//    endPointAssetsUrl: 'https://qaapi.enertics.ca/assets/',
//    endPointApplicationUrl: 'https://qaapi.enertics.ca/applications/',
//    endPointUploadUrl: 'https://qaapi.enertics.ca/upload/',
//    endPointMetricsUrl: 'https://qaapi.enertics.ca/metrics/',
//    endPointLicenceUrl: 'https://qaapi.enertics.ca/licence/',
//    endPointAssetServiceUrl: 'https://qaapi.enertics.ca/service/',
//    endPointDeviceStatusUrl: 'https://qaapi.enertics.ca/devicestatus/',
//    endPointAssetReportServiceUrl: 'https://qaapi.enertics.ca/report/',
//    endPointAlertServiceUrl: 'https://qaapi.enertics.ca/alerts/',
//    endPointErrorlogUrl:'https://qaapi.enertics.ca/alertreport/alert/status',
//    endPannelUrl:'https://qaapi.enertics.ca/alertreport/alert/error/',
//    endPointImageStorageUrl: 'https://enertics-prod.s3.ca-central-1.amazonaws.com/images/',
//    endPointUrl: 'https://73pzce80hf.execute-api.ca-central-1.amazonaws.com/development/v1/',
//    endpointkurtosisurl:'https://qaapi.enertics.ca/kurtosis/',
//    endPointKurtNumUrl:'https://qaapi.enertics.ca/kurtosis/v1/auto-regression/kurtosis/',
//    endPointAssetsListUrl:'https://qaapi.enertics.ca/user/users/assetCounter',
//   // endPointLocAssetsLisrUrl: 'https://qaapi.enertics.ca/middleware/userassets/'
//    endPointSubAssetsListUrl:'https://qaapi.enertics.ca/middleware/users/subsystem/assetCounter',
//    endPointCepstrumUrl: 'https://qaapi.enertics.ca/kurtosis/v1/gearbox/cepstrum',
//    endPointCresFactorUrl: 'https://qaapi.enertics.ca/kurtosis/v1/gearbox/cfs/',
//    endPointUltrasoundUrl: 'https://qaapi.enertics.ca/ultrasound/ultrasound/'
//  };

// export const environment = {
//     DSP:false,
//   production: true,
//   endPointLoginUrl: 'https://devapi.enertics.ca/login/',
//   endPointUserUrl: 'https://devapi.enertics.ca/user/',
//   endPointDeviceUrl: 'https://devapi.enertics.ca/device/',
//   endPointInventoryUrl: 'https://devapi.enertics.ca/inventory/',
//   endPointMiddlewareUrl: 'https://devapi.enertics.ca/middleware/',
//   endPointSitesUrl: 'https://devapi.enertics.ca/sites/',
//   endPointAssetsUrl: 'https://devapi.enertics.ca/assets/',
//   endPointApplicationUrl: 'https://devapi.enertics.ca/applications/',
//   endPointUploadUrl: 'https://devapi.enertics.ca/upload/',
//   endPointMetricsUrl: 'https://devapi.enertics.ca/metrics/',
//   endPointLicenceUrl: 'https://devapi.enertics.ca/licence/',
//   endPointAssetServiceUrl: 'https://devapi.enertics.ca/service/',
//   endPointDeviceStatusUrl: 'https://devapi.enertics.ca/devicestatus/',
//   endPointAssetReportServiceUrl: 'https://devapi.enertics.ca/report/',
//   endPointAlertServiceUrl: 'https://devv2api.enertics.ca/alerts/',
//   endPannelUrl:'https://devv2api.enertics.ca/alertreport/alert/error/',
//   endPointImageStorageUrl: 'https://enertics-prod.s3.ca-central-1.amazonaws.com/images/',
//   endPointUrl: 'https://73pzce80hf.execute-api.ca-central-1.amazonaws.com/development/v1/'
// };


// // new cg api

// export const environment = {
//   CG:true,
//     DSP:false,
//   production: false,
//   endPointLoginUrl: 'https://cgv2-api.enertics.ca/login/',
//   endPointUserUrl: 'https://cgv2-api.enertics.ca/user/',
//   endPointDeviceUrl: 'https://cgv2-api.enertics.ca/device/',
//   endPointInventoryUrl: 'https://cgv2-api.enertics.ca/inventory/',
//   endPointMiddlewareUrl: 'https://cgv2-api.enertics.ca/middleware/',
//   endPointSitesUrl: 'https://cgv2-api.enertics.ca/sites/',
//   endPointAssetsUrl: 'https://cgv2-api.enertics.ca/assets/',
//   endPointApplicationUrl: 'https://cgv2-api.enertics.ca/applications/',
//   endPointUploadUrl: 'https://cgv2-api.enertics.ca/upload/',
//   endPointMetricsUrl: 'https://cgv2-api.enertics.ca/metrics/',
//   endPointLicenceUrl: 'https://cgv2-api.enertics.ca/licence/',
//   endPointAssetServiceUrl: 'https://cgv2-api.enertics.ca/service/',
//   endPointDeviceStatusUrl: 'https://cgv2-api.enertics.ca/devicestatus/',
//   endPointAssetReportServiceUrl: 'https://cgv2-api.enertics.ca/report/',
//   endPointImageStorageUrl: 'https://enertics-prod.s3.ca-central-1.amazonaws.com/images/',
//   endPointUrl: 'https://73pzce80hf.execute-api.ca-central-1.amazonaws.com/development/v1/',
//   endpointkurtosisurl:'https://cgv2-api.enertics.ca/kurtosis/',
//   endPointKurtNumUrl:'https://cgv2-api.enertics.ca/kurtosis/v1/auto-regression/kurtosis/',
//   endPointAlertServiceUrl: 'https://cgv2-api.enertics.ca/alerts/',
//   endPointKurtosisPreDomURL: 'https://cgv2-api.enertics.ca/kurtosis/v1/auto-regression/predominant/',
//   endPointAssetsListUrl:'https://cgv2-api.enertics.ca/user/users/assetCounter',
//   endPointErrorlogUrl:'https://cgv2-api.enertics.ca/alertreport/alert/status',
//   endPannelUrl:'https://cgv2-api.enertics.ca/alertreport/alert/error/',
//   endPointSubAssetsListUrl:'https://cgv2-api.enertics.ca/middleware/users/subsystem/assetCounter',
//   endPointCepstrumUrl: 'https://cgv2-api.enertics.ca/kurtosis/v1/gearbox/cepstrum',
//   endPointCresFactorUrl: 'https://cgv2-api.enertics.ca/kurtosis/v1/gearbox/cfs/'
// };





// //for new preprod

export const environment = {
  CG:false,
 DSP:false,
  production: true,
  QA: false,
  mqtt: {
    server: '3.96.169.52',
    protocol: "ws",
    port: 9001
  },
  ON_PREM: false,
  BHEL_ON_PREM: false,
  endPointLoginUrl: 'https://em-in-api.enertics.ca/login/',
  endPointUserUrl: 'https://em-in-api.enertics.ca/user/',
  endPointDeviceUrl: 'https://em-in-api.enertics.ca/device/',
  endPointProductUrl: "https://em-in-api.enertics.ca/products/",
  endPointInventoryUrl: 'https://em-in-api.enertics.ca/inventory/',
  endPointMiddlewareUrl: 'https://em-in-api.enertics.ca/middleware/',
  endPointSitesUrl: 'https://em-in-api.enertics.ca/sites/',
  endPointKurtosisPreDomURL: 'https://em-in-api.enertics.ca/kurtosis/v1/auto-regression/predominant/',
  endPointAssetsUrl: 'https://em-in-api.enertics.ca/assets/',
  endPointApplicationUrl: 'https://em-in-api.enertics.ca/applications/',
  endPointUploadUrl: 'https://em-in-api.enertics.ca/upload/',
  endPointMetricsUrl: 'https://em-in-api.enertics.ca/metrics/',
  endPointLicenceUrl: 'https://em-in-api.enertics.ca/licence/',
  endPointAssetServiceUrl: 'https://em-in-api.enertics.ca/service/',
  endPointDeviceStatusUrl: 'https://em-in-api.enertics.ca/devicestatus/',
  endPointAssetReportServiceUrl: 'https://em-in-api.enertics.ca/report/',
  endPointAlertServiceUrl: 'https://em-in-api.enertics.ca/alerts/',
  endPointErrorlogUrl:'https://em-in-api.enertics.ca/alertreport/alert/status',
  endPannelUrl:'https://em-in-api.enertics.ca/alertreport/alert/error/',
  endPointImageStorageUrl: 'https://enertics-prod.s3.ca-central-1.amazonaws.com/images/',
  endPointUrl: 'https://73pzce80hf.execute-api.ca-central-1.amazonaws.com/development/v1/',
  endpointkurtosisurl:'https://em-in-api.enertics.ca/kurtosis/',
  endPointKurtNumUrl:'https://em-in-api.enertics.ca/kurtosis/v1/auto-regression/kurtosis/',
  endPointAssetsListUrl:'https://em-in-api.enertics.ca/user/users/assetCounter',
  endPointSubAssetsListUrl:'https://em-in-api.enertics.ca/middleware/users/subsystem/assetCounter',
  endPointCepstrumUrl: 'https://em-in-api.enertics.ca/kurtosis/v1/gearbox/cepstrum',
  endPointCresFactorUrl: 'https://em-in-api.enertics.ca/kurtosis/v1/gearbox/cfs/',
  endPointUltrasoundUrl: 'https://em-in-api.enertics.ca/ultrasound/ultrasound/',
  endPointTransformer: "https://em-in-api.enertics.ca/emformer/exformer",
  endPointEnergyMeter : "https://em-in-api.enertics.ca/emenergy/emeter",
  endPointMaintenance : "https://em-in-api.enertics.ca/maintenance",
  endPointeBoilerRoom:  "https://em-in-api.enertics.ca/eboiler/",
  endPointRotatingAssets: "https://em-in-api.enertics.ca/rotating_assets/userassets/",
  endPointMonitoring:"https://em-in-api.enertics.ca/monitoring/",
  endPointDiagnostics:"https://em-in-api.enertics.ca/diagnostics/",
  endPointPowertrain: "https://em-in-api.enertics.ca/powertrain/powertrain/",
  endPointPowertrainV2: "https://em-in-api.enertics.ca/powertrain/",
  endPointRotatingTabService: "https://em-in-api.enertics.ca/rotating_tab_service/",
  endPointHomeTabService: "https://em-in-api.enertics.ca/home_tab_service/",
  endPointOvenRootService:"https://em-in-api.enertics.ca/oven/",
  endPointCylinderService: "https://em-in-api.enertics.ca/cylinder-service",
  endPointGaugeService: "https://em-in-api.enertics.ca/gauge-monitoring",
  endPointDeviceUsageService: "https://em-in-api.enertics.ca/device_management_service",
  endPointSubscriptionUrl: "https://em-in-api.enertics.ca/subscription-service",
  endPointPiezoService: "https://em-in-api.enertics.ca/piezo_service",
  endPointUptimeService: "https://qaapi.enertics.ca/uptime_service",
  endPointRPMDetails: "https://em-in-api.enertics.ca/diagnostics/diagnostics/getRPMDetails",
  endPointPiezoMonitoringService: "https://em-in-api.enertics.ca/piezo-monitoring-api",
  endPointPiezoDiagnosticsService: "https://em-in-api.enertics.ca/piezo-diagnostics",
};


// //ssldspapii new

// export const environment = {
//   CG:false,
//   DSP:true,
//   production: false,
//   mqtt: {
//     server: 'localhost',
//     protocol: "ws",
//     port: 9001,
//     username:"Xornor",
//     password:"123"
//     // server: '3.96.169.52',
//     // protocol: "ws",
//     // port: 9001
//   },
//   endPointLoginUrl: 'https://iotdsp.saildsp.co.in/api/login/',
//   endPointUserUrl: 'https://iotdsp.saildsp.co.in/api/user/',
//    endPointKurtosisPreDomURL: 'https://iotdsp.saildsp.co.in/api/kurtosis/v1/auto-regression/predominant/',
//   endPointDeviceUrl: 'https://iotdsp.saildsp.co.in/api/device/',
//   endPointInventoryUrl: 'https://iotdsp.saildsp.co.in/api/inventory/',
//   endPointMiddlewareUrl: 'https://iotdsp.saildsp.co.in/api/middleware/',
//   endPointSitesUrl: 'https://iotdsp.saildsp.co.in/api/sites/',
//   endPointAssetsUrl: 'https://iotdsp.saildsp.co.in/api/assets/',
//   endPointApplicationUrl: 'https://iotdsp.saildsp.co.in/api/applications/',
//   endPointUploadUrl: 'https://iotdsp.saildsp.co.in/api/upload/',
//   endPointMetricsUrl: 'https://iotdsp.saildsp.co.in/api/metrics/',
//   endPointLicenceUrl: 'https://iotdsp.saildsp.co.in/api/licence/',
//   endPointAssetServiceUrl: 'https://iotdsp.saildsp.co.in/api/service/',
//   endPointDeviceStatusUrl: 'https://iotdsp.saildsp.co.in/api/devicestatus/',
//   endPointAssetReportServiceUrl: 'https://iotdsp.saildsp.co.in/api/report/',
//   endPointAlertServiceUrl: 'https://iotdsp.saildsp.co.in/api/alerts/',
//   endPointErrorlogUrl:'https://iotdsp.saildsp.co.in/api/alertreport/alert/status',
//   endPannelUrl:'https://iotdsp.saildsp.co.in/api/alertreport/alert/error/',
//   endPointImageStorageUrl: 'https://iotdsp.saildsp.co.in/api/images/',
//   //endPointUrl: 'https://73pzce80hf.execute-api.ca-central-1.amazonaws.com/development/v1/',
//   endPointUrl: 'https://iotdsp.saildsp.co.in/api/images/',
//   endpointkurtosisurl:'https://iotdsp.saildsp.co.in/api/kurtosis/',
//   endPointKurtNumUrl:'https://iotdsp.saildsp.co.in/api/kurtosis/v1/auto-regression/kurtosis/',
//   endPointAssetsListUrl:'https://iotdsp.saildsp.co.in/api/user/users/assetCounter',
//   endPointSubAssetsListUrl:'https://iotdsp.saildsp.co.in/api/middleware/users/subsystem/assetCounter',
//   endPointCepstrumUrl: 'https://iotdsp.saildsp.co.in/api/kurtosis/v1/gearbox/cepstrum',
//   endPointCresFactorUrl: 'https://iotdsp.saildsp.co.in/api/kurtosis/v1/gearbox/cfs/',
//   // endPointLocAssetsLisrUrl: 'http://iotdsp.saildsp.co.in/api/middleware/userassets/'
// };

//DSp with http
// export const environment = {
//   production: true,
//   mqtt: {
//     server: '3.96.169.52',
//     protocol: "ws",
//     port: 9001
//   },
//   endPointLoginUrl: 'http://api.iotdsp.saildsp.co.in/login/',
//   endPointUserUrl: 'http://api.iotdsp.saildsp.co.in/user/',
//   endPointDeviceUrl: 'http://api.iotdsp.saildsp.co.in/device/',
//   endPointInventoryUrl: 'http://api.iotdsp.saildsp.co.in/inventory/',
//   endPointMiddlewareUrl: 'http://api.iotdsp.saildsp.co.in/middleware/',
//   endPointSitesUrl: 'http://api.iotdsp.saildsp.co.in/sites/',
//   endPointKurtosisPreDomURL: 'http://api.iotdsp.saildsp.co.in/kurtosis/v1/auto-regression/predominant/',
//   endPointAssetsUrl: 'http://api.iotdsp.saildsp.co.in/assets/',
//   endPointApplicationUrl: 'http://api.iotdsp.saildsp.co.in/applications/',
//   endPointUploadUrl: 'http://api.iotdsp.saildsp.co.in/upload/',
//   endPointMetricsUrl: 'http://api.iotdsp.saildsp.co.in/metrics/',
//   endPointLicenceUrl: 'http://api.iotdsp.saildsp.co.in/licence/',
//   endPointAssetServiceUrl: 'http://api.iotdsp.saildsp.co.in/service/',
//   endPointDeviceStatusUrl: 'http://api.iotdsp.saildsp.co.in/devicestatus/',
//   endPointAssetReportServiceUrl: 'http://api.iotdsp.saildsp.co.in/report/',
//   endPointAlertServiceUrl: 'http://api.iotdsp.saildsp.co.in/alerts/',
//   endPointErrorlogUrl:'http://api.iotdsp.saildsp.co.in/alertreport/alert/status',
//   endPannelUrl:'http://api.iotdsp.saildsp.co.in/alertreport/alert/error/',
//   endPointImageStorageUrl: 'https://enertics-prod.s3.ca-central-1.amazonaws.com/images/',
//   endPointUrl: 'https://73pzce80hf.execute-api.ca-central-1.amazonaws.com/development/v1/',
//   endpointkurtosisurl:'http://api.iotdsp.saildsp.co.in/kurtosis/',
//   endPointKurtNumUrl:'http://api.iotdsp.saildsp.co.in/kurtosis/v1/auto-regression/kurtosis/',
// };

// export const environment = {
  //   DSP:false,
//   production: true,
//   endPointLoginUrl: 'http://35.183.208.57/login/',
//   endPointUserUrl: 'http://35.183.208.57/user/',
//   endPointDeviceUrl: 'http://35.183.208.57/device/',
//   endPointInventoryUrl: 'http://35.183.208.57/inventory/',
//   endPointMiddlewareUrl: 'http://35.183.208.57/middleware/',
//   endPointSitesUrl: 'http://35.183.208.57/sites/',
//   endPointAssetsUrl: 'http://35.183.208.57/assets/',
//   endPointApplicationUrl: 'http://35.183.208.57/applications/',
//   endPointUploadUrl: 'http://35.183.208.57/upload/',
//   endPointMetricsUrl: 'http://35.183.208.57/metrics/',
//   endPointLicenceUrl: 'http://35.183.208.57/licence/',
//   endPointAssetServiceUrl: 'http://35.183.208.57/service/',
//   endPointDeviceStatusUrl: 'http://35.183.208.57/devicestatus/',
//   endPointAssetReportServiceUrl: 'https://35.183.208.57/report/',
//   endPointImageStorageUrl: 'https://enertics-prod.s3.ca-central-1.amazonaws.com/images/',
//   endPointUrl: 'https://73pzce80hf.execute-api.ca-central-1.amazonaws.com/development/v1/'
// };


// export const environment = {
  //   DSP:false,
//   production: true,
//   endPointLoginUrl: 'http://52.60.131.56/login/',
//   endPointUserUrl: 'http://52.60.131.56/user/',
//   endPointDeviceUrl: 'http://52.60.131.56/device/',
//   endPointInventoryUrl: 'http://52.60.131.56/inventory/',
//   endPointMiddlewareUrl: 'http://52.60.131.56/middleware/',
//   endPointSitesUrl: 'http://52.60.131.56/sites/',
//   endPointAssetsUrl: 'http://52.60.131.56/assets/',
//   endPointApplicationUrl: 'http://52.60.131.56/applications/',
//   endPointUploadUrl: 'http://52.60.131.56/upload/',
//   endPointMetricsUrl: 'http://52.60.131.56/metrics/',
//   endPointLicenceUrl: 'http://52.60.131.56/licence/',
//   endPointAssetServiceUrl: 'http://52.60.131.56/service/',
//   endPointDeviceStatusUrl: 'http://52.60.131.56/devicestatus/',
//   endPointAssetReportServiceUrl: 'https://52.60.131.56/report/',
//   endPointImageStorageUrl: 'https://enertics-prod.s3.ca-central-1.amazonaws.com/images/',
//   endPointUrl: 'https://73pzce80hf.execute-api.ca-central-1.amazonaws.com/development/v1/'
// };




// export const environment = {
  //   DSP:false,
//   production: true,
//   endPointLoginUrl: 'http://localapi.enertics.ca/login/',
//   endPointUserUrl: 'http://localapi.enertics.ca/user/',
//   endPointDeviceUrl: 'http://localapi.enertics.ca/device/',
//   endPointInventoryUrl: 'http://localapi.enertics.ca/inventory/',
//   endPointMiddlewareUrl: 'http://localapi.enertics.ca/middleware/',
//   endPointSitesUrl: 'http://localapi.enertics.ca/sites/',
//   endPointAssetsUrl: 'http://localapi.enertics.ca/assets/',
//   endPointApplicationUrl: 'http://localapi.enertics.ca/applications/',
//   endPointUploadUrl: 'http://localapi.enertics.ca/upload/',
//   endPointMetricsUrl: 'http://localapi.enertics.ca/metrics/',
//   endPointLicenceUrl: 'http://localapi.enertics.ca/licence/',
//   endPointAssetServiceUrl: 'http://localapi.enertics.ca/service/',
//   endPointDeviceStatusUrl: 'http://localapi.enertics.ca/devicestatus/',
//   endPointUrl: 'https://73pzce80hf.execute-api.ca-central-1.amazonaws.com/development/v1/'
// };
